// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderLabelList-moduleEntityProfileHeaderLabelList__rcbXu";
export { _1 as "EntityProfileHeaderLabelList" }
